import type * as Types from '@xingternal/pages-graphql-types';

import * as Operations from './PublishPageMutation.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PublishPageMutationMutationVariables = Types.Exact<{
  input: Types.EntityPagePublicationStatusInput;
}>;


export type PublishPageMutationMutation = (
  { __typename?: 'Mutation' }
  & { entityPageUpdatePublicationStatus?: Types.Maybe<(
    { __typename?: 'EntityPageMutationResult' }
    & { error?: Types.Maybe<(
      { __typename?: 'EntityPagesMutationError' }
      & Pick<Types.EntityPagesMutationError, 'errorType' | 'errors'>
    )> }
  )> }
);


export type PublishPageMutationMutationFn = Apollo.MutationFunction<PublishPageMutationMutation, PublishPageMutationMutationVariables>;

/**
 * __usePublishPageMutationMutation__
 *
 * To run a mutation, you first call `usePublishPageMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishPageMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishPageMutationMutation, { data, loading, error }] = usePublishPageMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublishPageMutationMutation(baseOptions?: Apollo.MutationHookOptions<PublishPageMutationMutation, PublishPageMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishPageMutationMutation, PublishPageMutationMutationVariables>(Operations.publishPageMutation, options);
      }
export type PublishPageMutationMutationHookResult = ReturnType<typeof usePublishPageMutationMutation>;
export type PublishPageMutationMutationResult = Apollo.MutationResult<PublishPageMutationMutation>;
export type PublishPageMutationMutationOptions = Apollo.BaseMutationOptions<PublishPageMutationMutation, PublishPageMutationMutationVariables>;